import React from 'react';
import { Stack, Toast, ToastContainer } from 'react-bootstrap';
import { useAlert } from '../../context/AlertContext';
import ConfirmModal from '../modals/ConfirmModal';
import GlobalModals from '../modals/GlobalModals';

/**
 * AuthLayout
 * Layout simplificado para páginas de autenticación (Login, Registro, etc.)
 * - No incluye Navbar ni Sidebar
 * - Incluye soporte para Modals y Toasts globales
 */
function AuthLayout({ children }) {
    const { alertState, hideAlert, toastState, hideToast } = useAlert();

    const handleConfirm = () => {
        if (alertState.onConfirm) {
            alertState.onConfirm();
        }
        hideAlert();
    };

    return (
        <Stack style={{ minHeight: '100vh', backgroundColor: '#f0f2f5' }}>
            {/* Global Toast Notification */}
            <ToastContainer position="top-end" className="p-3">
                <Toast
                    show={toastState.show}
                    onClose={hideToast}
                    bg={toastState.variant}
                    delay={5000}
                    autohide
                >
                    <Toast.Header closeButton={true}>
                        <strong className="me-auto">
                            {toastState.variant === 'success' ? 'Éxito' :
                                toastState.variant === 'danger' ? 'Error' :
                                    toastState.variant === 'warning' ? 'Advertencia' : 'Información'}
                        </strong>
                    </Toast.Header>
                    <Toast.Body className={toastState.variant === 'light' ? '' : 'text-white'}>
                        {toastState.message}
                    </Toast.Body>
                </Toast>
            </ToastContainer>

            {/* Main Content (Centered) */}
            <div className="d-flex align-items-center justify-content-center flex-grow-1">
                {children}
            </div>

            {/* Global Confirm Modal */}
            <ConfirmModal
                show={alertState.show}
                onHide={hideAlert}
                title={alertState.title}
                message={alertState.message}
                alertVariant={alertState.alertVariant}
                confirmLabel={alertState.confirmLabel}
                cancelLabel={alertState.cancelLabel}
                confirmVariant={alertState.confirmVariant}
                onConfirm={handleConfirm}
            />

            {/* Global Modals */}
            <GlobalModals />
        </Stack>
    );
}

export default AuthLayout;
